import { useState, useRef } from 'react'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

const useOnScroll = () => {
  const [scrolledTo, setScrolledTo] = useState(false)
  const scrollRef = useRef()

  const handleScroll = ({ currPos }) => {
    if (scrolledTo === false && currPos.y <= 0) setScrolledTo(true)
    if (scrolledTo === true && currPos.y >= 0) setScrolledTo(false)
  }

  useScrollPosition(handleScroll, [scrolledTo], scrollRef)

  return {
    scrollRef,
    scrolledTo,
  }
}

export default useOnScroll
